import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, LibraryImportExistingInventoryModeType, LibraryImportNonSummaryRowsModeType } from '../../../store/Models/Api/SftpImportModels';
import { RadioButton } from '../../core/RadioButton';
import { DropdownMenu } from '../../core/DropdownMenu';

interface ImportLibrarySettingsModalLocalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    configData: SftpImportConfigurationWorkflow;
    onConfigChange: (data: Partial<SftpImportConfigurationWorkflow>) => void;
}

type ImportLibrarySettingsModalProps = ImportLibrarySettingsModalLocalProps & ToxnotComponentProperties;

class ImportLibrarySettingsModalComponent extends ToxnotComponent<ImportLibrarySettingsModalProps> {

    render() {
        if (!this.props.show) {
            return null;
        }

        const { configData } = this.props;

        return (
            <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.props.onClose}>&times;</button>
                            <h4 className="modal-title">{this.localizeString("Import Library Settings")}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="alert alert-info">
                                {this.localizeString("How would you like to handle any existing products or materials referenced by this import?")}
                            </div>
                            <div className="form-group">
                                <RadioButton
                                    name={this.localizeString("Overwrite Existing Products/Materials with the Import")}
                                    value={LibraryImportExistingInventoryModeType.OverwriteExisting}
                                    selected={configData.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.OverwriteExisting}
                                    onValueChange={() => this.props.onConfigChange({ libraryImportExistingInventoryMode: LibraryImportExistingInventoryModeType.OverwriteExisting })}
                                />
                                <div style={{ paddingLeft: '30px', display: configData.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.OverwriteExisting ? 'block' : 'none' }}>
                                    <div className="form-inline">
                                        <label style={{ marginRight: '10px' }}>{this.localizeString("Should existing summary rows be updated?")}</label>
                                        <DropdownMenu
                                            options={[
                                                { text: this.localizeString('Yes, update summary rows with new uploaded data.'), value: 'yes' },
                                                { text: this.localizeString('No, do not update summary rows.'), value: 'no' }
                                            ]}
                                            getFriendlyNameForOptions={(option) => option.text}
                                            getUniqueValueForOption={(option) => option.value}
                                            value={configData.libraryImportShouldUpdateSummaryRows ? 
                                                { text: this.localizeString('Yes, update summary rows with new uploaded data.'), value: 'yes' } :
                                                { text: this.localizeString('No, do not update summary rows.'), value: 'no' }}
                                            onOptionSelected={(option) => this.props.onConfigChange({ 
                                                libraryImportShouldUpdateSummaryRows: option.value === 'yes' 
                                            })}
                                        />
                                    </div>
                                    <div className="form-inline" style={{ marginTop: '10px' }}>
                                        <label style={{ marginRight: '10px' }}>{this.localizeString("Should existing material content rows be updated?")}</label>
                                        <DropdownMenu
                                            options={[
                                                { text: this.localizeString('Yes, delete current content rows and replace with imported data.'), value: 'replace' },
                                                { text: this.localizeString('No, leave existing content rows as-is.'), value: 'leave' }
                                            ]}
                                            getFriendlyNameForOptions={(option) => option.text}
                                            getUniqueValueForOption={(option) => option.value}
                                            value={configData.libraryImportNonSummaryRowsMode === LibraryImportNonSummaryRowsModeType.ReplaceNonSummaryRows ? 
                                                { text: this.localizeString('Yes, delete current content rows and replace with imported data.'), value: 'replace' } :
                                                { text: this.localizeString('No, leave existing content rows as-is.'), value: 'leave' }}
                                            onOptionSelected={(option) => this.props.onConfigChange({ 
                                                libraryImportNonSummaryRowsMode: option.value === 'replace' ? 
                                                    LibraryImportNonSummaryRowsModeType.ReplaceNonSummaryRows : 
                                                    LibraryImportNonSummaryRowsModeType.LeaveNonSummaryRowsIntact 
                                            })}
                                        />
                                    </div>
                                </div>
                                <RadioButton
                                    name={this.localizeString("Import Conflicts as New Products/Materials with Updated Names (e.g. My Product (2))")}
                                    value={LibraryImportExistingInventoryModeType.WriteNewWithUniquifiedName}
                                    selected={configData.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.WriteNewWithUniquifiedName}
                                    onValueChange={() => this.props.onConfigChange({ libraryImportExistingInventoryMode: LibraryImportExistingInventoryModeType.WriteNewWithUniquifiedName })}
                                />
                                <RadioButton
                                    name={this.localizeString("Skip any Import Conflicts - don't import data that references existing products/materials")}
                                    value={LibraryImportExistingInventoryModeType.SkipExisting}
                                    selected={configData.libraryImportExistingInventoryMode === LibraryImportExistingInventoryModeType.SkipExisting}
                                    onValueChange={() => this.props.onConfigChange({ libraryImportExistingInventoryMode: LibraryImportExistingInventoryModeType.SkipExisting })}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={this.props.onClose}>{this.localizeString("Cancel")}</button>
                            <button type="button" className="btn btn-toxnot-primary" onClick={this.props.onConfirm}>{this.localizeString("Proceed with Import")}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const ImportLibrarySettingsModal = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ImportLibrarySettingsModalComponent);